"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71682],{

/***/ 6474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ getCashInfo; },
  "S": function() { return /* binding */ getCashOnHand; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/global/Securities/constants/apiEndpoints/balance.ts
var balanceEndpoint = {
    cashInfo: "/balance/cash/info",
    cashOnHand: "/balance/cash"
};
/* harmony default export */ var balance = (balanceEndpoint);

// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/balance.ts




var getCashInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode, orderId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashInfo, {
                        params: {
                            stock_code: stockCode,
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashInfo(stockCode, orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getCashOnHand = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashOnHand));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashOnHand() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 29541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useBondOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);






var initialState = {
    selected: undefined,
    list: [],
    isLoading: false,
    isLoadingList: false
};
var useBondOrder = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetails: function loadOrderDetails(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var list, index, response, _data, order;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            list = get().list;
                            index = list.findIndex(function(data) {
                                return data.id === id;
                            });
                            if (!(index >= 0)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                selected: list[index],
                                isLoading: false
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderDetail */ .iC)(id);
                        case 9:
                            response = _ctx.sent;
                            _data = response.data, order = _data.data.order;
                            set({
                                selected: order,
                                isLoading: false
                            });
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        loadOrderList: function loadOrderList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, _data, orders;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderList */ .R0)();
                        case 4:
                            response = _ctx.sent;
                            _data = response.data, orders = _data.data.orders;
                            set({
                                list: orders,
                                isLoadingList: false
                            });
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false
                            });
                            Promise.reject(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        clearSelected: function clearSelected() {
            set({
                selected: null
            });
        },
        clearList: function clearList() {
            set({
                list: []
            });
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 42427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useBondPreviewStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);







var initialState = {
    buy: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialBuyPreview */ .dX,
    sell: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialSellPreview */ .Bv,
    product: undefined,
    isLoading: false
};
var useBondPreviewStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadBuyPreview: /**
   * We override the response when receive unit value <= 0
   *
   * This behavior is needed to provide the initial value of the buy modal
   *
   * We will show the 0 values to the user,
   *    except the buy price `price_rate` value.
   *
   */ function loadBuyPreview(productId) {
            var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().buy.price_rate;
                            if (!(isZeroUnit && priceRate)) {
                                _ctx.next = 6;
                                break;
                            }
                            set({
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: priceRate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 6:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondBuyPreview */ .UU)({
                                product_id: productId,
                                /**
         * We will set the unit to 1 if the unit is 0 or negative value
         * So it will still calls the API without any errors
         */ unit: isZeroUnit ? 1 : unit
                            });
                        case 9:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 14;
                                break;
                            }
                            set({
                                // we store the product information
                                product: data.product,
                                isLoading: false,
                                // override response
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: data.price_rate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 14:
                            set({
                                buy: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 21;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                product: initialState.product,
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadSellPreview: function loadSellPreview(productId, acquisitionOrderId) {
            var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, availableUnit, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().sell.price.sell;
                            availableUnit = get().sell.available_units;
                            if (!(isZeroUnit && priceRate && availableUnit)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    available_units: availableUnit,
                                    // exception, price.sell is needed to show the selling price
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        sell: priceRate
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            if (productId) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Product Code is required");
                        case 9:
                            if (acquisitionOrderId) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error("Order id is required");
                        case 11:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 14;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondSellPreview */ .QY)({
                                product_id: productId,
                                acquisition_order_id: acquisitionOrderId,
                                unit: isZeroUnit ? 1 : unit
                            });
                        case 14:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 19;
                                break;
                            }
                            set({
                                product: data.product,
                                isLoading: false,
                                // override the sell preview response with initial state
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    // exception, available unit
                                    available_units: data.available_units,
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        // except the price sell data
                                        sell: data.price.sell
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 19:
                            set({
                                sell: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 26;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useBondTransaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73921);
/* harmony import */ var _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78311);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42427);









var initialState = {
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    productId: "",
    unit: 0,
    acquisitionOrderId: "",
    priceRate: 0,
    isLoading: false,
    isTnCAccepted: false,
    isSuccess: false
};
var useBondTransaction = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialState), {
        submitOrder: function submitOrder() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, isTnCAccepted, transactionType, acquisitionOrderId, buy, sell;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            ref = get(), isTnCAccepted = ref.isTnCAccepted, transactionType = ref.transactionType, acquisitionOrderId = ref.acquisitionOrderId;
                            if (isTnCAccepted) {
                                _ctx.next = 5;
                                break;
                            }
                            throw new Error("Terms and Condition is required");
                        case 5:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY)) {
                                _ctx.next = 9;
                                break;
                            }
                            buy = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().buy;
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondBuy */ .yt)({
                                price_rate: buy.price_rate,
                                product_id: buy.product.id,
                                unit: parseInt(buy.unit, 10)
                            });
                        case 9:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL)) {
                                _ctx.next = 13;
                                break;
                            }
                            sell = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().sell;
                            _ctx.next = 13;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondSell */ .OF)({
                                product_id: sell.product.id,
                                buy_order_id: acquisitionOrderId,
                                unit: sell.units,
                                price_rate: sell.price.sell
                            });
                        case 13:
                            // inform the ui layer that the transaction is success
                            set({
                                isLoading: false,
                                isSuccess: true
                            });
                            _ctx.next = 20;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                isSuccess: false
                            });
                            Promise.reject(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }))();
        },
        clearData: function clearData() {
            set(initialState);
        },
        setTnC: function setTnC(value) {
            set({
                isTnCAccepted: value
            });
        },
        initiateBuyTransaction: function initiateBuyTransaction(productId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadBuyPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadBuyPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadBuyPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadBuyPreview(productId)
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        initiateSellTransaction: function initiateSellTransaction(productId, acquisitionOrderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadSellPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadSellPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadSellPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                acquisitionOrderId: acquisitionOrderId,
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadSellPreview(productId, acquisitionOrderId, 1), 
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        reInitiateTransaction: function reInitiateTransaction() {
            set({
                unit: 0,
                priceRate: 0,
                isTnCAccepted: false,
                isSuccess: false
            });
        }
    });
});


/***/ }),

/***/ 81557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBondsModalStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73921);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);
/* harmony import */ var _useBondOrder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29541);
/* harmony import */ var _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29176);
/* harmony import */ var _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55847);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42427);












var initialState = {
    isLoading: false,
    error: undefined,
    isSearchActive: false,
    isAllowedToSearch: false,
    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED,
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondsModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, initialState), {
        toggleSearch: function toggleSearch(state) {
            if (typeof state === "boolean") {
                set({
                    isSearchActive: state
                });
                return;
            }
            set(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), {
                    isSearchActive: !prev.isSearchActive
                });
            });
        },
        openConfirmModal: function openConfirmModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
            });
        },
        openBlockerModal: function openBlockerModal(blockerType) {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                blockerType: blockerType
            });
        },
        openTncModal: function openTncModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC
            });
        },
        openCouponReceipt: function openCouponReceipt(orderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, couponHistories, loadPortfolioDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState(), couponHistories = ref.couponHistories, loadPortfolioDetails = ref.loadPortfolioDetails;
                            if (couponHistories) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return loadPortfolioDetails(orderId, true);
                        case 4:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.COUPON_RECEIPT */ ._y.COUPON_RECEIPT
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderModal: function openOrderModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER */ ._y.ORDER
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderHistoryModal: function openOrderHistoryModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.HISTORY */ ._y.HISTORY
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openBuyModal: function openBuyModal(productId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateBuyTransaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            initiateBuyTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateBuyTransaction;
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.BUY */ .qB.BUY,
                                isAllowedToSearch: true,
                                sourcePage: sourcePage
                            });
                            _ctx.next = 5;
                            return initiateBuyTransaction(productId);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        openSellModal: function openSellModal(productId, orderId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateSellTransaction, loadPortfolioDetails, transactions, _transactions, transaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            // store the source page
                            if (sourcePage) {
                                set({
                                    sourcePage: sourcePage
                                });
                            }
                            if (!orderId) {
                                _ctx.next = 8;
                                break;
                            }
                            initiateSellTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateSellTransaction;
                            _ctx.next = 6;
                            return initiateSellTransaction(productId, orderId);
                        case 6:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
                                isAllowedToSearch: false
                            });
                            return _ctx.abrupt("return");
                        case 8:
                            loadPortfolioDetails = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().loadPortfolioDetails;
                            _ctx.next = 11;
                            return loadPortfolioDetails(productId);
                        case 11:
                            transactions = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().transactions;
                            if (!(transactions.length === 1)) {
                                _ctx.next = 19;
                                break;
                            }
                            _transactions = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(transactions, 1), transaction = _transactions[0];
                            if (!transaction.is_stable_earn) {
                                _ctx.next = 17;
                                break;
                            }
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                                blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.STABLE_EARN */ .Ew.STABLE_EARN
                            });
                            return _ctx.abrupt("return");
                        case 17:
                            get().openSellModal(productId, transaction.order_code);
                            return _ctx.abrupt("return");
                        case 19:
                            // open the assets / product selection modal
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ASSETS */ ._y.ASSETS
                            });
                            _ctx.next = 25;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        openOrderPlacedModal: function openOrderPlacedModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER_PLACED */ ._y.ORDER_PLACED
            });
        },
        reOpenTransactionModal: function reOpenTransactionModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
            });
        },
        closeModal: function closeModal() {
            var ref = get(), modalType = ref.modalType, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            if (isSearchActive) {
                toggleSearch();
            }
            if (modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC) {
                // back to confirmation
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
                });
                return;
            }
            // back to the transaction
            var product = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState().product;
            var isBackToTransaction = modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION;
            if (isBackToTransaction && product) {
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
                });
                return;
            }
            // Close the modal
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED
            });
        },
        closeTransactionModal: function closeTransactionModal() {
            var ref = get(), closeModal = ref.closeModal, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            var clearData = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().clearData;
            var ref1 = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState(), clearPreview = ref1.clear;
            var clearPortfolioList = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().clearPortfolioList;
            if (isSearchActive) {
                toggleSearch();
            }
            clearPreview();
            clearPortfolioList();
            clearData();
            closeModal();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 78311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCashOnHandStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    cashOnHand: 0,
    isLoading: false
};
var useCashOnHandStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadBalance: function loadBalance() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashOnHand */ .S)();
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                cashOnHand: data.available_cash_on_hand
                            });
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false,
    trailingStop: undefined
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setPrice: function(price) {
            set({
                price: price
            });
        },
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ })

}]);